// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/BodoniSvtyTwoITCTT-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M5.33301 1.33301V3.33301%27 stroke=%27%237CA6BD%27 stroke-width=%271.5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M10.667 1.33301V3.33301%27 stroke=%27%237CA6BD%27 stroke-width=%271.5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M2.33301 6.05957H13.6663%27 stroke=%27%237CA6BD%27 stroke-width=%271.5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M14 5.66634V11.333C14 13.333 13 14.6663 10.6667 14.6663H5.33333C3 14.6663 2 13.333 2 11.333V5.66634C2 3.66634 3 2.33301 5.33333 2.33301H10.6667C13 2.33301 14 3.66634 14 5.66634Z%27 stroke=%27%237CA6BD%27 stroke-width=%271.5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M10.4625 9.13314H10.4685%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M10.4625 11.1331H10.4685%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M7.99666 9.13314H8.00265%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M7.99666 11.1331H8.00265%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M5.52987 9.13314H5.53585%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M5.52987 11.1331H5.53585%27 stroke=%27%237CA6BD%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2718%27 viewBox=%270 0 18 18%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5ZM9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3ZM9 4.5C9.1837 4.50002 9.361 4.56747 9.49828 4.68954C9.63556 4.81161 9.72326 4.97981 9.74475 5.16225L9.75 5.25V8.6895L11.7802 10.7198C11.9148 10.8547 11.9929 11.0358 11.9987 11.2263C12.0045 11.4167 11.9376 11.6023 11.8116 11.7452C11.6855 11.8881 11.5098 11.9777 11.3201 11.9958C11.1305 12.0139 10.941 11.9591 10.7902 11.8425L10.7198 11.7802L8.46975 9.53025C8.35318 9.41358 8.27832 9.26175 8.25675 9.09825L8.25 9V5.25C8.25 5.05109 8.32902 4.86032 8.46967 4.71967C8.61032 4.57902 8.80109 4.5 9 4.5Z%27 fill=%27%238692A4%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alex+Brush&family=Libre+Bodoni:ital,wght@0,400..700;1,400..700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Bodoni 72';
	src:
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
	font-weight: bold;
	font-style: normal;
	font-display: swap;
}

/* ========= COMMON CSS  ========== */
:root {
	--font-inter: 'Inter', sans-serif;
	--font-alex: 'Alex Brush', cursive;
	--font-bodoni: 'Libre Bodoni', serif;
	--font-bodoni-72: 'Bodoni 72', serif;

	/* =========== updated colors ========== */
	--primary-Text: #313131;
	--secondary-Text: #8692a4;
	--white: #ffffff;
	--brand: #7ca6bd;
	--border: #dfe4eb;
	--placeholder: #9aa4b3;
	--bg1: #faf4f2;
	--bg2: #e1d4cf;
	--bg3: #f2f6f8;
	--error: #f44336;
	--warning: #ff9b21;
	--success: #4caf50;
	--black: #000;

	--success-300: #87c98a;

	/* Custom font properties  */
	--h1: normal 400 40px/48px var(--font-inter);
	--h2: normal 400 36px/43px var(--font-inter);
	--h3: normal 400 32px/38.4px var(--font-inter);
	--h4: normal 400 28px/33.6px var(--font-inter);
	--h5: normal 400 24px/28.8px var(--font-inter);
	--h6: normal 400 20px/24px var(--font-inter);

	--body-font-one: normal 400 18px/25.2px var(--font-inter);
	--body-font-two: normal 500 16px/22px var(--font-inter);
	--body-font-three: normal 400 14px/19.6px var(--font-inter);
	--body-font-four: normal 400 12px/16.8px var(--font-inter);

	--gradient-1: linear-gradient(117.35deg, #faf4f2 9.63%, #e1d4cf 143.03%);

	/* Border Radius */
	--border-radius: 8px;
	--border-radius-large: 12px;
	--border-radius-full: 100%;
}
body {
	font-family: var(--font-inter);
	font-size: var(--body-font-one);
	/* background-color: var(--background-color); */
	color: var(--primary-Text);
	/* transition: all 0.2s ease-in-out; */
	width: 100%;
	box-sizing: border-box;
}

/* Scrollbar (WebKit-based browsers like Chrome, Edge, Safari) */
::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
	background: var(--white);
	border-radius: 1000px;
}

/* Thumb */
::-webkit-scrollbar-thumb {
	background-color: var(--brand);
	border-radius: 10000px;
	border: 0;
	background-clip: padding-box;
}

*,
*::before,
*::after {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	/* transition: all 0.2s ease-in-out; */
}
.container {
	max-width: 1280px;
	width: 100%;
	margin: 0 auto;
	padding: 0 15px;
}
img {
	display: inline-block;
	width: 100%;
}
a {
	margin: 0;
	padding: 0;
	cursor: pointer;
}
ul,
li {
	list-style: none;
	margin: 0;
	padding: 0;
}

/* overwrite existing main css */
.afterLoginMain {
	display: flex;
	flex-direction: row;
	align-items: unset;
	overflow-x: unset;
	scrollbar-width: none;
	height: auto;
}
.afterLoginMainLayout {
	flex: 1 1;
	padding: 64px 0 0 50px;
	/* margin-left: 50px; */
	/* overflow-x: hidden; */
	width: 100%;
	transition: all 0.2s ease-in-out;
}

.afterLoginNavbar {
	padding: 0 25px 0 65px;
}

.sidebar-expand .SideNavbar {
	max-width: 240px;
	left: 0;
}
.sidebar-expand .afterLoginNavbar {
	padding: 0 25px 0 260px;
}
.sidebar-expand .afterLoginMainLayout {
	padding: 64px 0 0 240px;
	/* margin-left: 240px; */
	width: 100%;
}

/* back button */

.backButton {
	font: var(--body-font-two) !important;
	color: var(--primary-color) !important;
	cursor: pointer !important;
	background: transparent !important;
	padding: 0 !important;
	min-width: unset !important;
}
/* ------- table common css --------- */
.table-wrp .img-with-text-wrp {
	display: flex;
	align-items: center;
}
.table-wrp .img-with-text,
.table-wrp .role-text {
	color: #313131;
	font: var(--body-font-three);
	font-weight: 600;
	/* text-transform: capitalize; */
}
.table-wrp .role-text {
	font-weight: 500;
}
/* .table-wrp .MuiDataGrid-iconSeparator, {
	display: none;
} */
.table-wrp .MuiDataGrid-row {
	border-radius: 8px !important;
	border: 1px solid #dfe4eb;
	margin: 7px 0;
}
.table-wrp .MuiDataGrid-cell {
	border-top: unset !important;
}
.table-wrp .MuiDataGrid-columnHeader,
.table-wrp .MuiDataGrid-cell {
	outline: unset !important;
}
.table-wrp .priority-icon {
	display: flex;
	align-items: center;
	gap: 5px;
}
.table-wrp .priority-icon img,
.table-wrp .priority-icon svg {
	width: 16px;
	height: 16px;
}
.addMemberFieldRow .MuiFormHelperText-root {
	position: absolute;
	bottom: -13px;
	line-height: 1;
}

/* ===== common calendar css start ===== */
.calendarWrp {
	border: 1px solid var(--border);
	border-radius: 15px;
	overflow: hidden;
}
.calendarWrp .e-schedule .e-table-container {
	max-height: calc(100dvh - 50dvh) !important;
	overflow-y: auto !important;
	border-top: 1px solid var(--border);
}
.calendarWrp.vendorTask .e-schedule .e-table-container {
	max-height: calc(100dvh - 30dvh) !important;
}
.calendarWrp .e-schedule {
	border: unset;
	background-color: var(--white) !important;
}
.calendarWrp .e-toolbar .e-toolbar-items {
	background: var(--white);
	height: 54px !important;
	min-height: 54px !important;
}
.calendarWrp .e-schedule .e-schedule-toolbar {
	border-bottom: 0;
	box-shadow: unset;
	margin-bottom: 0;
	min-height: 54px;
	background-color: #fff;
	border-bottom: 1px solid var(--border);
}
body .calendarWrp .e-toolbar .e-toolbar-item .e-tbar-btn {
	background: transparent;
	box-shadow: none;
	border: none;
}
.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-left {
	width: 33.33%;
	padding-left: 10px;
}
.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-center {
	margin: 0 auto !important;
	width: 33.33%;
	display: flex;
	justify-content: center;
}

.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right {
	width: 33.33%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-right: 10px;
}
.calendarWrp #task-title .e-tbar-btn-text {
	font-weight: 600;
	font-size: 16px;
	color: var(--primary-Text);
	text-transform: capitalize !important;
}
.calendarWrp .calendar-btn {
	padding: 5px 12px;
	background-color: var(--white);
	color: #8692a4;
	border: 1px solid var(--border);
	font-size: 12px;
	text-align: center;
	font-weight: 500;
	line-height: 1;
	border-radius: 6px;
}
.calendarWrp .calendar-btn:hover,
.calendarWrp .e-active-view .calendar-btn {
	background-color: #f2f6f8;
	color: #7ca6bd;
	border: 1px solid #7ca6bd;
}
.calendarWrp .e-date-range .e-tbar-btn-text {
	font-weight: 600;
	color: #313131;
}
/* Hide the default calendar icon */
input[type='date']::-webkit-calendar-picker-indicator {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-size: 16px 16px;
	color: transparent;
	opacity: 1;
	cursor: pointer;
	width: 16px;
	height: 16px;
}
/* Hide the default time icon */
input[type='time']::-webkit-calendar-picker-indicator {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-size: 16px 16px;
	color: transparent;
	opacity: 1;
	cursor: pointer;
	width: 16px;
	height: 16px;
}
.prioritySelect {
	display: flex;
	align-items: center;
	gap: 5px;
	font: var(--body-font-four);
	font-weight: 500;
	text-transform: capitalize;
	color: var(--primary-Text);
}
.prioritySelect img,
.prioritySelect svg {
	width: 16px;
	height: 16px;
	object-fit: scale-down;
	display: block;
}
.header-column-right .MuiDataGrid-columnHeaderTitleContainer {
	justify-content: flex-end;
}
.MuiYearCalendar-root button.MuiYearCalendar-button {
	padding: 7px !important;
	line-height: 1 !important;
	font-size: 14px !important;
	text-align: center !important;
}
.MuiYearCalendar-root button.MuiYearCalendar-button:hover {
	background-color: var(--brand) !important;
	color: var(--white) !important;
}

.text-error{
	color: var(--error);
	font-size: 13px;
	font-weight: 500;
	line-height: 1.3;
	text-align: left;
	margin-top: 5px;
}

@media (max-width: 1170px) {
	:root {
		--h1: normal 400 36px/1.3 var(--font-inter);
		--h2: normal 400 32px/1.3 var(--font-inter);
		--h3: normal 400 28px/1.3 var(--font-inter);
		--h4: normal 400 24px/1.3 var(--font-inter);
		--h5: normal 400 20px/1.3 var(--font-inter);
		--h6: normal 400 18px/1.3 var(--font-inter);
		--body-font-one: normal 400 16px/1.3 var(--font-inter);
	}
}

@media (max-width: 991px) {
	:root {
		--h1: normal 400 34px/1.3 var(--font-inter);
		--h2: normal 400 30px/1.3 var(--font-inter);
		--h3: normal 400 26px/1.3 var(--font-inter);
		--h4: normal 400 22px/1.3 var(--font-inter);
		--h5: normal 400 18px/1.3 var(--font-inter);
		--h6: normal 400 16px/1.3 var(--font-inter);
	}
}
@media (max-width: 767px) {
	:root {
		--h1: normal 400 32px/1.3 var(--font-inter);
		--h2: normal 400 28px/1.3 var(--font-inter);
		--h3: normal 400 24px/1.3 var(--font-inter);
		--h4: normal 400 20px/1.3 var(--font-inter);
		--h5: normal 400 16px/1.3 var(--font-inter);
	}
	.sidebar-expand .overlay {
		position: fixed;
		top: 0;
		left: 0;
		background: #00000057;
		width: 100%;
		height: 100%;
		z-index: 3;
	}
	.sidebar-expand {
		overflow-y: hidden;
	}
	.afterLoginMainLayout {
		padding: 64px 0 0 0 !important;
		margin-left: 0 !important;
	}
	.afterLoginNavbar {
		padding: 0 15px;
	}
	.sidebar-expand .afterLoginNavbar {
		padding: 0 15px;
	}
}
@media (max-width: 575px) {
	:root {
		--h1: normal 400 30px/1.3 var(--font-inter);
		--h2: normal 400 26px/1.3 var(--font-inter);
		--h3: normal 400 22px/1.3 var(--font-inter);
		--h4: normal 400 18px/1.3 var(--font-inter);
		--h5: normal 400 14px/1.3 var(--font-inter);
	}
}

/* Date/time picker calendar must sit above MUI modals (wedding wizard is z-index 2000). */
.MuiPopper-root.MuiPickerPopper-root {
	z-index: 9999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAIA;CACC,wBAAwB;CACxB;;wDAEiE;CACjE,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA,qCAAqC;AACrC;CACC,iCAAiC;CACjC,kCAAkC;CAClC,oCAAoC;CACpC,oCAAoC;;CAEpC,0CAA0C;CAC1C,uBAAuB;CACvB,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;;CAEb,sBAAsB;;CAEtB,4BAA4B;CAC5B,4CAA4C;CAC5C,4CAA4C;CAC5C,8CAA8C;CAC9C,8CAA8C;CAC9C,8CAA8C;CAC9C,4CAA4C;;CAE5C,yDAAyD;CACzD,uDAAuD;CACvD,2DAA2D;CAC3D,0DAA0D;;CAE1D,wEAAwE;;CAExE,kBAAkB;CAClB,oBAAoB;CACpB,2BAA2B;CAC3B,0BAA0B;AAC3B;AACA;CACC,8BAA8B;CAC9B,+BAA+B;CAC/B,+CAA+C;CAC/C,0BAA0B;CAC1B,sCAAsC;CACtC,WAAW;CACX,sBAAsB;AACvB;;AAEA,gEAAgE;AAChE;CACC,UAAU;CACV,WAAW;AACZ;;AAEA,UAAU;AACV;CACC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA,UAAU;AACV;CACC,8BAA8B;CAC9B,sBAAsB;CACtB,SAAS;CACT,4BAA4B;AAC7B;;AAEA;;;CAGC,SAAS;CACT,UAAU;CACV,sBAAsB;CACtB,sCAAsC;AACvC;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,eAAe;AAChB;AACA;CACC,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,SAAS;CACT,UAAU;CACV,eAAe;AAChB;AACA;;CAEC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA,gCAAgC;AAChC;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,SAAO;CACP,sBAAsB;CACtB,uBAAuB;CACvB,wBAAwB;CACxB,WAAW;CACX,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,OAAO;AACR;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,WAAW;AACZ;;AAEA,gBAAgB;;AAEhB;CACC,qCAAqC;CACrC,sCAAsC;CACtC,0BAA0B;CAC1B,kCAAkC;CAClC,qBAAqB;CACrB,2BAA2B;AAC5B;AACA,uCAAuC;AACvC;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;;CAEC,cAAc;CACd,4BAA4B;CAC5B,gBAAgB;CAChB,gCAAgC;AACjC;AACA;CACC,gBAAgB;AACjB;AACA;;GAEG;AACH;CACC,6BAA6B;CAC7B,yBAAyB;CACzB,aAAa;AACd;AACA;CACC,4BAA4B;AAC7B;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;AACA;;CAEC,WAAW;CACX,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;;AAEA,0CAA0C;AAC1C;CACC,+BAA+B;CAC/B,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,mCAAmC;AACpC;AACA;CACC,2CAA2C;AAC5C;AACA;CACC,aAAa;CACb,yCAAyC;AAC1C;AACA;CACC,wBAAwB;CACxB,uBAAuB;CACvB,2BAA2B;AAC5B;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,sCAAsC;AACvC;AACA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,aAAa;CACb,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,qCAAqC;AACtC;AACA;CACC,iBAAiB;CACjB,8BAA8B;CAC9B,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA,mCAAmC;AACnC;CACC,yDAAsmD;CACtmD,0BAA0B;CAC1B,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,WAAW;CACX,YAAY;AACb;AACA,+BAA+B;AAC/B;CACC,yDAAwlC;CACxlC,0BAA0B;CAC1B,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,WAAW;CACX,YAAY;AACb;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,2BAA2B;CAC3B,gBAAgB;CAChB,0BAA0B;CAC1B,0BAA0B;AAC3B;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,0BAA0B;CAC1B,6BAA6B;AAC9B;AACA;CACC,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC;EACC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,sDAAsD;CACvD;AACD;;AAEA;CACC;EACC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;CAC5C;AACD;AACA;CACC;EACC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;CAC5C;CACA;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;CACX;CACA;EACC,kBAAkB;CACnB;CACA;EACC,8BAA8B;EAC9B,yBAAyB;CAC1B;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;CAC5C;AACD;;AAEA,0FAA0F;AAC1F;CACC,wBAAwB;AACzB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Alex+Brush&family=Libre+Bodoni:ital,wght@0,400..700;1,400..700&display=swap');\r\n\r\n@font-face {\r\n\tfont-family: 'Bodoni 72';\r\n\tsrc:\r\n\t\turl('/public/fonts/BodoniSvtyTwoITCTT-Bold.woff') format('woff2'),\r\n\t\turl('/public/fonts/BodoniSvtyTwoITCTT-Bold.woff') format('woff');\r\n\tfont-weight: bold;\r\n\tfont-style: normal;\r\n\tfont-display: swap;\r\n}\r\n\r\n/* ========= COMMON CSS  ========== */\r\n:root {\r\n\t--font-inter: 'Inter', sans-serif;\r\n\t--font-alex: 'Alex Brush', cursive;\r\n\t--font-bodoni: 'Libre Bodoni', serif;\r\n\t--font-bodoni-72: 'Bodoni 72', serif;\r\n\r\n\t/* =========== updated colors ========== */\r\n\t--primary-Text: #313131;\r\n\t--secondary-Text: #8692a4;\r\n\t--white: #ffffff;\r\n\t--brand: #7ca6bd;\r\n\t--border: #dfe4eb;\r\n\t--placeholder: #9aa4b3;\r\n\t--bg1: #faf4f2;\r\n\t--bg2: #e1d4cf;\r\n\t--bg3: #f2f6f8;\r\n\t--error: #f44336;\r\n\t--warning: #ff9b21;\r\n\t--success: #4caf50;\r\n\t--black: #000;\r\n\r\n\t--success-300: #87c98a;\r\n\r\n\t/* Custom font properties  */\r\n\t--h1: normal 400 40px/48px var(--font-inter);\r\n\t--h2: normal 400 36px/43px var(--font-inter);\r\n\t--h3: normal 400 32px/38.4px var(--font-inter);\r\n\t--h4: normal 400 28px/33.6px var(--font-inter);\r\n\t--h5: normal 400 24px/28.8px var(--font-inter);\r\n\t--h6: normal 400 20px/24px var(--font-inter);\r\n\r\n\t--body-font-one: normal 400 18px/25.2px var(--font-inter);\r\n\t--body-font-two: normal 500 16px/22px var(--font-inter);\r\n\t--body-font-three: normal 400 14px/19.6px var(--font-inter);\r\n\t--body-font-four: normal 400 12px/16.8px var(--font-inter);\r\n\r\n\t--gradient-1: linear-gradient(117.35deg, #faf4f2 9.63%, #e1d4cf 143.03%);\r\n\r\n\t/* Border Radius */\r\n\t--border-radius: 8px;\r\n\t--border-radius-large: 12px;\r\n\t--border-radius-full: 100%;\r\n}\r\nbody {\r\n\tfont-family: var(--font-inter);\r\n\tfont-size: var(--body-font-one);\r\n\t/* background-color: var(--background-color); */\r\n\tcolor: var(--primary-Text);\r\n\t/* transition: all 0.2s ease-in-out; */\r\n\twidth: 100%;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n/* Scrollbar (WebKit-based browsers like Chrome, Edge, Safari) */\r\n::-webkit-scrollbar {\r\n\twidth: 4px;\r\n\theight: 4px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n\tbackground: var(--white);\r\n\tborder-radius: 1000px;\r\n}\r\n\r\n/* Thumb */\r\n::-webkit-scrollbar-thumb {\r\n\tbackground-color: var(--brand);\r\n\tborder-radius: 10000px;\r\n\tborder: 0;\r\n\tbackground-clip: padding-box;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tbox-sizing: border-box;\r\n\t/* transition: all 0.2s ease-in-out; */\r\n}\r\n.container {\r\n\tmax-width: 1280px;\r\n\twidth: 100%;\r\n\tmargin: 0 auto;\r\n\tpadding: 0 15px;\r\n}\r\nimg {\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n}\r\na {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tcursor: pointer;\r\n}\r\nul,\r\nli {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n/* overwrite existing main css */\r\n.afterLoginMain {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: unset;\r\n\toverflow-x: unset;\r\n\tscrollbar-width: none;\r\n\theight: auto;\r\n}\r\n.afterLoginMainLayout {\r\n\tflex: 1;\r\n\tpadding: 64px 0 0 50px;\r\n\t/* margin-left: 50px; */\r\n\t/* overflow-x: hidden; */\r\n\twidth: 100%;\r\n\ttransition: all 0.2s ease-in-out;\r\n}\r\n\r\n.afterLoginNavbar {\r\n\tpadding: 0 25px 0 65px;\r\n}\r\n\r\n.sidebar-expand .SideNavbar {\r\n\tmax-width: 240px;\r\n\tleft: 0;\r\n}\r\n.sidebar-expand .afterLoginNavbar {\r\n\tpadding: 0 25px 0 260px;\r\n}\r\n.sidebar-expand .afterLoginMainLayout {\r\n\tpadding: 64px 0 0 240px;\r\n\t/* margin-left: 240px; */\r\n\twidth: 100%;\r\n}\r\n\r\n/* back button */\r\n\r\n.backButton {\r\n\tfont: var(--body-font-two) !important;\r\n\tcolor: var(--primary-color) !important;\r\n\tcursor: pointer !important;\r\n\tbackground: transparent !important;\r\n\tpadding: 0 !important;\r\n\tmin-width: unset !important;\r\n}\r\n/* ------- table common css --------- */\r\n.table-wrp .img-with-text-wrp {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n.table-wrp .img-with-text,\r\n.table-wrp .role-text {\r\n\tcolor: #313131;\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 600;\r\n\t/* text-transform: capitalize; */\r\n}\r\n.table-wrp .role-text {\r\n\tfont-weight: 500;\r\n}\r\n/* .table-wrp .MuiDataGrid-iconSeparator, {\r\n\tdisplay: none;\r\n} */\r\n.table-wrp .MuiDataGrid-row {\r\n\tborder-radius: 8px !important;\r\n\tborder: 1px solid #dfe4eb;\r\n\tmargin: 7px 0;\r\n}\r\n.table-wrp .MuiDataGrid-cell {\r\n\tborder-top: unset !important;\r\n}\r\n.table-wrp .MuiDataGrid-columnHeader,\r\n.table-wrp .MuiDataGrid-cell {\r\n\toutline: unset !important;\r\n}\r\n.table-wrp .priority-icon {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n}\r\n.table-wrp .priority-icon img,\r\n.table-wrp .priority-icon svg {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n}\r\n.addMemberFieldRow .MuiFormHelperText-root {\r\n\tposition: absolute;\r\n\tbottom: -13px;\r\n\tline-height: 1;\r\n}\r\n\r\n/* ===== common calendar css start ===== */\r\n.calendarWrp {\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 15px;\r\n\toverflow: hidden;\r\n}\r\n.calendarWrp .e-schedule .e-table-container {\r\n\tmax-height: calc(100dvh - 50dvh) !important;\r\n\toverflow-y: auto !important;\r\n\tborder-top: 1px solid var(--border);\r\n}\r\n.calendarWrp.vendorTask .e-schedule .e-table-container {\r\n\tmax-height: calc(100dvh - 30dvh) !important;\r\n}\r\n.calendarWrp .e-schedule {\r\n\tborder: unset;\r\n\tbackground-color: var(--white) !important;\r\n}\r\n.calendarWrp .e-toolbar .e-toolbar-items {\r\n\tbackground: var(--white);\r\n\theight: 54px !important;\r\n\tmin-height: 54px !important;\r\n}\r\n.calendarWrp .e-schedule .e-schedule-toolbar {\r\n\tborder-bottom: 0;\r\n\tbox-shadow: unset;\r\n\tmargin-bottom: 0;\r\n\tmin-height: 54px;\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid var(--border);\r\n}\r\nbody .calendarWrp .e-toolbar .e-toolbar-item .e-tbar-btn {\r\n\tbackground: transparent;\r\n\tbox-shadow: none;\r\n\tborder: none;\r\n}\r\n.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-left {\r\n\twidth: 33.33%;\r\n\tpadding-left: 10px;\r\n}\r\n.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-center {\r\n\tmargin: 0 auto !important;\r\n\twidth: 33.33%;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.calendarWrp .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right {\r\n\twidth: 33.33%;\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\talign-items: center;\r\n\tpadding-right: 10px;\r\n}\r\n.calendarWrp #task-title .e-tbar-btn-text {\r\n\tfont-weight: 600;\r\n\tfont-size: 16px;\r\n\tcolor: var(--primary-Text);\r\n\ttext-transform: capitalize !important;\r\n}\r\n.calendarWrp .calendar-btn {\r\n\tpadding: 5px 12px;\r\n\tbackground-color: var(--white);\r\n\tcolor: #8692a4;\r\n\tborder: 1px solid var(--border);\r\n\tfont-size: 12px;\r\n\ttext-align: center;\r\n\tfont-weight: 500;\r\n\tline-height: 1;\r\n\tborder-radius: 6px;\r\n}\r\n.calendarWrp .calendar-btn:hover,\r\n.calendarWrp .e-active-view .calendar-btn {\r\n\tbackground-color: #f2f6f8;\r\n\tcolor: #7ca6bd;\r\n\tborder: 1px solid #7ca6bd;\r\n}\r\n.calendarWrp .e-date-range .e-tbar-btn-text {\r\n\tfont-weight: 600;\r\n\tcolor: #313131;\r\n}\r\n/* Hide the default calendar icon */\r\ninput[type='date']::-webkit-calendar-picker-indicator {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.33301 1.33301V3.33301' stroke='%237CA6BD' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.667 1.33301V3.33301' stroke='%237CA6BD' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2.33301 6.05957H13.6663' stroke='%237CA6BD' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M14 5.66634V11.333C14 13.333 13 14.6663 10.6667 14.6663H5.33333C3 14.6663 2 13.333 2 11.333V5.66634C2 3.66634 3 2.33301 5.33333 2.33301H10.6667C13 2.33301 14 3.66634 14 5.66634Z' stroke='%237CA6BD' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.4625 9.13314H10.4685' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.4625 11.1331H10.4685' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M7.99666 9.13314H8.00265' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M7.99666 11.1331H8.00265' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5.52987 9.13314H5.53585' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5.52987 11.1331H5.53585' stroke='%237CA6BD' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\r\n\tbackground-size: 16px 16px;\r\n\tcolor: transparent;\r\n\topacity: 1;\r\n\tcursor: pointer;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n}\r\n/* Hide the default time icon */\r\ninput[type='time']::-webkit-calendar-picker-indicator {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5ZM9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3ZM9 4.5C9.1837 4.50002 9.361 4.56747 9.49828 4.68954C9.63556 4.81161 9.72326 4.97981 9.74475 5.16225L9.75 5.25V8.6895L11.7802 10.7198C11.9148 10.8547 11.9929 11.0358 11.9987 11.2263C12.0045 11.4167 11.9376 11.6023 11.8116 11.7452C11.6855 11.8881 11.5098 11.9777 11.3201 11.9958C11.1305 12.0139 10.941 11.9591 10.7902 11.8425L10.7198 11.7802L8.46975 9.53025C8.35318 9.41358 8.27832 9.26175 8.25675 9.09825L8.25 9V5.25C8.25 5.05109 8.32902 4.86032 8.46967 4.71967C8.61032 4.57902 8.80109 4.5 9 4.5Z' fill='%238692A4'/%3E%3C/svg%3E%0A\");\r\n\tbackground-size: 16px 16px;\r\n\tcolor: transparent;\r\n\topacity: 1;\r\n\tcursor: pointer;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n}\r\n.prioritySelect {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n\tfont: var(--body-font-four);\r\n\tfont-weight: 500;\r\n\ttext-transform: capitalize;\r\n\tcolor: var(--primary-Text);\r\n}\r\n.prioritySelect img,\r\n.prioritySelect svg {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tobject-fit: scale-down;\r\n\tdisplay: block;\r\n}\r\n.header-column-right .MuiDataGrid-columnHeaderTitleContainer {\r\n\tjustify-content: flex-end;\r\n}\r\n.MuiYearCalendar-root button.MuiYearCalendar-button {\r\n\tpadding: 7px !important;\r\n\tline-height: 1 !important;\r\n\tfont-size: 14px !important;\r\n\ttext-align: center !important;\r\n}\r\n.MuiYearCalendar-root button.MuiYearCalendar-button:hover {\r\n\tbackground-color: var(--brand) !important;\r\n\tcolor: var(--white) !important;\r\n}\r\n\r\n.text-error{\r\n\tcolor: var(--error);\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\tline-height: 1.3;\r\n\ttext-align: left;\r\n\tmargin-top: 5px;\r\n}\r\n\r\n@media (max-width: 1170px) {\r\n\t:root {\r\n\t\t--h1: normal 400 36px/1.3 var(--font-inter);\r\n\t\t--h2: normal 400 32px/1.3 var(--font-inter);\r\n\t\t--h3: normal 400 28px/1.3 var(--font-inter);\r\n\t\t--h4: normal 400 24px/1.3 var(--font-inter);\r\n\t\t--h5: normal 400 20px/1.3 var(--font-inter);\r\n\t\t--h6: normal 400 18px/1.3 var(--font-inter);\r\n\t\t--body-font-one: normal 400 16px/1.3 var(--font-inter);\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t:root {\r\n\t\t--h1: normal 400 34px/1.3 var(--font-inter);\r\n\t\t--h2: normal 400 30px/1.3 var(--font-inter);\r\n\t\t--h3: normal 400 26px/1.3 var(--font-inter);\r\n\t\t--h4: normal 400 22px/1.3 var(--font-inter);\r\n\t\t--h5: normal 400 18px/1.3 var(--font-inter);\r\n\t\t--h6: normal 400 16px/1.3 var(--font-inter);\r\n\t}\r\n}\r\n@media (max-width: 767px) {\r\n\t:root {\r\n\t\t--h1: normal 400 32px/1.3 var(--font-inter);\r\n\t\t--h2: normal 400 28px/1.3 var(--font-inter);\r\n\t\t--h3: normal 400 24px/1.3 var(--font-inter);\r\n\t\t--h4: normal 400 20px/1.3 var(--font-inter);\r\n\t\t--h5: normal 400 16px/1.3 var(--font-inter);\r\n\t}\r\n\t.sidebar-expand .overlay {\r\n\t\tposition: fixed;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tbackground: #00000057;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tz-index: 3;\r\n\t}\r\n\t.sidebar-expand {\r\n\t\toverflow-y: hidden;\r\n\t}\r\n\t.afterLoginMainLayout {\r\n\t\tpadding: 64px 0 0 0 !important;\r\n\t\tmargin-left: 0 !important;\r\n\t}\r\n\t.afterLoginNavbar {\r\n\t\tpadding: 0 15px;\r\n\t}\r\n\t.sidebar-expand .afterLoginNavbar {\r\n\t\tpadding: 0 15px;\r\n\t}\r\n}\r\n@media (max-width: 575px) {\r\n\t:root {\r\n\t\t--h1: normal 400 30px/1.3 var(--font-inter);\r\n\t\t--h2: normal 400 26px/1.3 var(--font-inter);\r\n\t\t--h3: normal 400 22px/1.3 var(--font-inter);\r\n\t\t--h4: normal 400 18px/1.3 var(--font-inter);\r\n\t\t--h5: normal 400 14px/1.3 var(--font-inter);\r\n\t}\r\n}\r\n\r\n/* Date/time picker calendar must sit above MUI modals (wedding wizard is z-index 2000). */\r\n.MuiPopper-root.MuiPickerPopper-root {\r\n\tz-index: 9999 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
